import { render, staticRenderFns } from "./MenuPricingDetails.vue?vue&type=template&id=7521629c&scoped=true&"
import script from "./MenuPricingDetails.vue?vue&type=script&lang=js&"
export * from "./MenuPricingDetails.vue?vue&type=script&lang=js&"
import style0 from "./MenuPricingDetails.vue?vue&type=style&index=0&id=7521629c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7521629c",
  null
  
)

export default component.exports